import {get, post} from 'external/axios';

export class CourseService {
	async getOffersCourses(idPrograms, idSubject, language) {
		return get(`/offer/courses/${idPrograms}/${idSubject}/${language}`);
	}

	async getCoursesForOffer(offerId) {
		return get(`/offer/courses/${offerId}`);
	}

	async getCoursesDetails(courseId) {
		return get(`/catalog/courses-detail/${courseId}`)
	}

	async getCourseBySubjectAll() {
		return get(`/catalog/coursesBySubject/all`)
	}

	async getCourseBySubjectConfiguration(offerId) {
		return get(`/catalog/coursesBySubject/configuration/${offerId}`)
	}
}

export const courseService = new CourseService();